import Head from 'next/head';
import { GetServerSideProps } from 'next';
import ProfilePage, { ProfilePageModules } from '@/Page/ProfilePage';
import { sharedServerSideLogic } from '@/Services/SsrService/sharedServerSideLogic';

export default function Profile_MyPosts() {
  return (
    <>
      <Head>
        <title>Joyla.uz</title>
        <meta name='description' content='Joyla' />
        <meta name='viewport' content='width=device-width, initial-scale=1' />
        <link rel='icon' href='/static/favicon.ico' />
      </Head>
      <>
        <ProfilePage moduleName={ProfilePageModules.my_posts} />
      </>
    </>
  );
}

export const getServerSideProps: GetServerSideProps = sharedServerSideLogic();
